import g from '#core/global';
import load from '#core/load';


const mask_$ = '[data-pixel-mask]';
const cells_$ = '[data-pixel-mask-cells]';
const cell_class = 'pixel-mask__cell';
const revealed_attr = 'data-revealed';
const ready_attr = 'data-pixel-mask-ready';
const index_prop = '--pixel-mask-cell-index';
const columns_prop = '--pixel-mask-columns';
const rows_prop = '--pixel-mask-rows';

const margins = '0px 0px -10% 0px';

let initialized = false;


const module = {

	/**
	 * Init module
	 */
	init() {
		if (load.ran('pixel-mask')) return false;

		load.content(() => {
			assign_elements();
		});
		load.all(() => {
			assign_elements();
		});
	},

};

export default module;
module.init();


/**
 * Find pixel-mask wrappers, populate cells, and observe for reveal
 */
function assign_elements() {
	const $masks = document.querySelectorAll(mask_$);
	if (!$masks.length) return false;

	$masks.forEach($mask => {
		if ($mask.getAttribute(ready_attr)) return false;
		$mask.setAttribute(ready_attr, '1');

		populate_cells($mask);
	});

	if (!initialized) {
		initialized = true;
		setup_observer();
	}
}


/**
 * Build the cell grid for a single mask
 * @param {HTMLElement} $mask
 */
function populate_cells($mask) {
	const $cells = $mask.querySelector(cells_$);
	if (!$cells) return false;
	if ($cells.children.length) return false;

	const styles = window.getComputedStyle($mask);
	const cols = parseInt(styles.getPropertyValue(columns_prop), 10) || 0;
	const rows = parseInt(styles.getPropertyValue(rows_prop), 10) || 0;
	const total = cols * rows;
	if (!total) return false;

	const order = shuffled_indices(total);
	const fragment = document.createDocumentFragment();

	for (let i = 0; i < total; i++) {
		const $cell = document.createElement('span');
		$cell.className = cell_class;
		// Reveal order: position i in DOM gets shuffled order index
		$cell.style.setProperty(index_prop, order[i]);
		fragment.appendChild($cell);
	}

	$cells.appendChild(fragment);
}


/**
 * Watch for masks entering viewport and trigger reveal
 */
function setup_observer() {
	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (!entry.isIntersecting) return;
			entry.target.setAttribute(revealed_attr, '');
			observer.unobserve(entry.target);
		});
	}, { rootMargin: margins });

	document.querySelectorAll(mask_$).forEach($mask => {
		if ($mask.hasAttribute(revealed_attr)) return false;
		observer.observe($mask);
	});
}


/**
 * Fisher-Yates shuffle producing an array of indices [0..n-1] in random order
 * @param {number} n
 * @return {number[]}
 */
function shuffled_indices(n) {
	const arr = Array.from({ length: n }, (_, i) => i);
	for (let i = n - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[arr[i], arr[j]] = [arr[j], arr[i]];
	}
	return arr;
}
